import _ from 'lodash';
import React from 'react';

export const Truncate = ({ length, text }) => {
  return _.truncate(text, { length: length, separator: ' ' });
};
